import { render } from "./new-event.vue?vue&type=template&id=70e3c018"
import script from "./new-event.vue?vue&type=script&lang=js"
export * from "./new-event.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__